module.exports = __webpack_public_path__ + "img/crm.7d28cafb.png";